<app-header></app-header>
<div class="main" [class.main-big]="isBigRoute">
    <router-outlet></router-outlet>
</div>